import React from "react";
import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";
import { ACRA_URL } from "@util/constant";

/**
 * Component to render Accounting and Corporate Regulatory Authority section on Partners page
 */
const ACRASection = (): React.ReactElement => {
  return (
    <div className="bg-gray-150" data-testid="acra-section-component">
      <AccordionV2
        testId="acra"
        className="border-l border-r py-4"
        headerChildren={
          <EventsAwardsAccordionHeader title="Accounting and Corporate Regulatory Authority" />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mt-4 border-t border-gray-175 px-6 py-4 pt-4">
          <p>
            The Accounting and Corporate Regulatory Authority (ACRA) is the
            regulator of business registration, financial reporting, public
            accountants and corporate service providers; it also facilitates
            enterprise. We provide a trusted and vibrant environment for
            businesses to thrive and flourish, and contribute towards making
            Singapore the best place for business.
          </p>

          <p>
            For more information, please visit&nbsp;
            <a
              className="text-blue-175 hover:text-gray-750"
              href={ACRA_URL}
              target="_blank"
              rel="noreferrer"
            >
              www.acra.gov.sg
            </a>
            .
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default ACRASection;
